import { Observable, of } from 'rxjs';
import { IPaginationResponse, IPaginationParameters, ICreateEntitiesRequest } from '../../../../core';
import { Injectable } from '@angular/core';
import { UserManagementCollections } from '../../../common';
import { UserContextService } from '../../../auth-management';
import { IAccountUsersApiClient } from './i-account-users.api.client';
import { ICreateUserRequest, IUserResponse } from '../../../system-management';
import { IChangeAccountUserPasswordRequest, IUpdateUserRequest } from '../dtos';
import { usersData } from '../data/usersData';

@Injectable({
  providedIn: 'root'
})
export class AccountUsersInMemoryApiClientProvider implements IAccountUsersApiClient {
  get(paginationParameters?: IPaginationParameters): Observable<IPaginationResponse<IUserResponse>> {
    return of(usersData.usersResponse);
  }

  getById(id: string): Observable<IUserResponse> {
    return of(usersData.userResponse);
  }

  create(request: ICreateUserRequest): Observable<IUserResponse> {
    return of(usersData.userResponse);
  }

  update(id: string, request: IUpdateUserRequest): Observable<void> {
    return of();
  }

  assignSpecializedRoles(id: string, request: ICreateEntitiesRequest): Observable<void> {
    return of();
  }

  revokeSpecializedRoles(id: string, request: ICreateEntitiesRequest): Observable<void> {
    return of();
  }

  changePassword(id: string, request: IChangeAccountUserPasswordRequest): Observable<void> {
    return of();
  }

  getCollectionUrl(): string {
    return UserManagementCollections.AccountUsers(UserContextService.getUserContext()?.accountId || '');
  }
}
